import detectResultRender from './detectResult.render'
import labelRender from './label.render'
import shieldLineRender from './shieldLine.render'
import shieldManuallyRender from './shieldManually.render'

export const render = {
  DETECT_RESULT: detectResultRender,
  LABEL: labelRender,
  SHIELD_LINE: shieldLineRender,
  SHIELD_MANUALLY: shieldManuallyRender,
}
